<template>
  <div
    class="f-center h-100 csst csst_nm"
    @click.stop
  >
    <!-- --clr-disabled: var(--clr-grey-2); -->
    <Checkbox
      :value="value"
      style="
        --icon-size: 1.25rem;
        --clr-disabled: var(--clr-grey-2);
        --clr-enabled: var(--clr-yellow);
      "
      :icons="['mdi-star-outline', 'mdi-star']"
      @input="val => $emit('input', val)"
    />
    <div
      class="csst_content text-nowrap"
      style="left: calc(100% + 0.5rem)"
    >
      {{ value ? $t(`tooltips.show_all`) : $t(`tooltips.show_starred_only`) }}
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/Common/Checkbox/Checkbox'

export default {
  name: 'TableFilterStar',
  components: {
    Checkbox,
  },
  props: {
    value: [Boolean, String],
  },
  emits: ['input'],
}
</script>
